import { FaTrash } from "react-icons/fa";

const AdminAnnouncementCard = ({
    handleAnnouncementDelete,
    id,
    title,
    priority,
    description,
    link,
}) => {
    let bgColor =
        priority === "Urgent"
            ? "has-background-danger-light"
            : "has-background-info-light";

    bgColor =
        priority === "Important" ? "has-background-warning-light" : bgColor;

    return (
        <div
            className={`card ${bgColor}`}
            style={{ width: "100%", textAlign: "center" }}
        >
            <div className="card-content">
                <div className="media">
                    <div className="media-content">
                        <h1 className="title is-4">{title}</h1>
                        <p
                            style={{
                                whiteSpace: "pre-wrap",
                            }}
                            className="subtitle"
                        >
                            {description}
                        </p>
                        <p className="has-text-link">{link}</p>
                    </div>
                </div>
            </div>
            <footer className="card-footer">
                <button
                    className="button card-footer-item"
                    onClick={() => handleAnnouncementDelete(id)}
                >
                    <FaTrash color="tomato" />
                </button>
            </footer>
        </div>
    );
};

export default AdminAnnouncementCard;
